import React from 'react';

// Blocco visivo CONDIVISO per una superserie in esecuzione (scheda + libero).
// Non contiene logica di stato: riceve gli esercizi già risolti e una render-prop
// `renderCard(exercise, indexInGroup)` che disegna la card di esecuzione del
// singolo esercizio (così ogni flusso mantiene il proprio wiring dei set).

const PALETTE = [
  { bar: '#3b82f6', bg: '#eff6ff', fg: '#1e40af' }, // blu
  { bar: '#10b981', bg: '#ecfdf5', fg: '#065f46' }, // verde
  { bar: '#a855f7', bg: '#faf5ff', fg: '#6b21a8' }, // viola
  { bar: '#ec4899', bg: '#fdf2f8', fg: '#9f1239' }, // rosa
  { bar: '#f59e0b', bg: '#fffbeb', fg: '#92400e' }, // giallo
];

// Colore stabile derivato dall'id del gruppo (indipendente dalla lettera scheda).
const colorFor = (id) => {
  let h = 0;
  for (const ch of String(id)) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
};

function SupersetBlock({ group, exercises, renderCard, onDissolve, restEditable, onSetRest }) {
  const c = colorFor(group.id);
  // PB-011: il "Recupero tra i giri" è una proprietà della superserie.
  // null/0 = nessun recupero (nessun timer a fine giro). Nessun default 90.
  const rest = group?.restSeconds;
  const restLabel = rest > 0 ? `recupero tra i giri: ${rest}s` : 'nessun recupero tra i giri';
  return (
    <div className="bg-white rounded-xl p-4 shadow-md" style={{ borderLeft: `4px solid ${c.bar}` }}>
      {/* Header superserie — due righe: pill + azione, poi riepilogo completo.
          Il riepilogo sta su una riga propria a tutta larghezza (niente truncate)
          così resta leggibile anche su schermi piccoli (iPhone SE/mini). */}
      <div className="mb-3">
        <div className="flex items-center justify-between gap-2">
          <span
            className="px-3 py-1 rounded-full text-sm font-bold whitespace-nowrap"
            style={{ backgroundColor: c.bg, color: c.fg }}
          >
            🔗 SUPERSET
          </span>
          {onDissolve && (
            <button
              type="button"
              onClick={onDissolve}
              className="text-xs font-medium text-gray-400 hover:text-red-500 transition-colors flex-none"
            >
              Sciogli
            </button>
          )}
        </div>
        {restEditable ? (
          <div className="text-xs text-gray-500 mt-1 flex items-center flex-wrap gap-1.5">
            <span>{exercises.length} esercizi · recupero tra i giri</span>
            <input
              type="number"
              min="0"
              inputMode="numeric"
              placeholder="—"
              defaultValue={rest ?? ''}
              onBlur={(e) => onSetRest && onSetRest(e.target.value)}
              className="w-14 px-1.5 py-0.5 border border-gray-300 rounded text-xs"
              aria-label="Recupero tra i giri (secondi)"
            />
            <span>s</span>
          </div>
        ) : (
          <p className="text-xs text-gray-500 mt-1">
            {exercises.length} esercizi · {restLabel}
          </p>
        )}
      </div>

      {/* Esercizi del blocco, con badge di posizione */}
      {exercises.map((ex, i) => (
        <div key={ex.id} className="mb-3 last:mb-0">
          <div className="text-xs font-semibold text-gray-500 mb-1">
            {i + 1}/{exercises.length}
          </div>
          {renderCard(ex, i)}
        </div>
      ))}
    </div>
  );
}

export default SupersetBlock;
